module.exports = __webpack_public_path__ + "static/media/ponto-apoio.d0acb24f.svg";